export enum CobInvoiceType {
    PdrCases = 1,
    _837p = 2
}

export enum ChangeRequestApprovalStatus {
    Pending = 1,
    Approved = 2,
    Rejected = 3,
    Cancelled = 4
}

export const CobPayerTabs = {
    PayerInfo: "payer-info",
    ChangeRequests: "change-requests",
    AuditHistory: "audit-history"
} as const;

export const CobPayerValidation = {
    PayerCodeMaxLength: 50,
    PayerNameMaxLength: 200,
    PayerDetailMaxLength: 100,
    AddressLineMaxLength: 110,
    CityMaxLength: 60,
    StateCodeMaxLength: 4,
    ZipCodeMaxLength: 9,
    ContactPhoneMaxLength: 10,
    NoteMaxLength: 300,
    ChangeReasonMaxLength: 300
} as const;

export const CobPayerPaging = {
    DefaultPageIndex: 1,
    DefaultPageSize: 10
} as const;

export const CobPayerSort = {
    CreatedDateField: "createdDate",
    ModifiedDateField: "modifiedDate",
    ChangeRequestDateField: "changeRequestDate",
    DefaultDateField: "defaultDate",
    DefaultOrder: "descend"
} as const;

export const CobPayerPatterns = {
    PayerCode: /^[A-Z0-9]+$/,
    RemoveNonAlphanumeric: /[^A-Z0-9]/g,
    PayerName: /^[^'"]+$/,
    RemoveQuotes: /['"]/g,
    Numeric: /^\d*$/,
    RemoveNonNumeric: /\D/g
} as const;
